module.exports = require("./eu-ES.js");